import styled from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';

const ScrollingContainer = styled.div`
  position: relative;
  width: 100%;
  background-color: transparent;
  overflow: hidden;
  z-index: 1;
  margin: 0 20px;
  padding: 0;
`;

const InnerScroll = styled.div`
  overflow: hidden;
  white-space: nowrap;
  animation: scrollText 40s infinite linear;
  margin: 0;
  font-size: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: fit-content;

  @keyframes scrollText {
    from {
      transform: translateX(0%);
    }
    to {
      transform: translateX(-50%);
    }
  }
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const InnerContainer = styled.div`
  max-width: calc(1440px + 48px);
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 48px;
  padding-left: 24px;
  padding-right: 24px;
  @media ${PHONE_MEDIA_QUERY} {
    gap: 32px;
    max-width: unset;
    padding-left: 16px;
    padding-right: 16px;
    flex-direction: ${({ avoidDirectionChange }) =>
      avoidDirectionChange ? 'row' : 'column'};
  }
`;

const RowComponent = ({
  children,
  style = {},
  innerContainerStyle = {},
  avoidDirectionChange = false,
}) => {
  return (
    <Row style={style}>
      <InnerContainer
        style={innerContainerStyle}
        avoidDirectionChange={avoidDirectionChange}
      >
        {children}
      </InnerContainer>
    </Row>
  );
};

const HorizontalScroll = ({ icons }) => {
  return (
    <ScrollingContainer>
      <InnerScroll>
        {icons.map((icon, index) => (
          <div key={index}>{icon}</div>
        ))}
        {icons.map((icon, index) => (
          <div key={index}>{icon}</div>
        ))}
      </InnerScroll>
    </ScrollingContainer>
  );
};

const IconContainer = styled.div`
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 50px;
  margin-right: 50px;
`;

const Icon = styled.img`
  width: 100%;
  filter: grayscale(100%);
`;

const Icons = [
  '/pricing/partners/AWOKE.webp',
  '/pricing/partners/BILLY.webp',
  '/pricing/partners/BUNKER.webp',
  '/pricing/partners/ME.webp',
  '/pricing/partners/MOOMOO.webp',
  '/pricing/partners/MPLX.webp',
  '/pricing/partners/ORDER.webp',
  '/pricing/partners/SNS.webp',
  '/pricing/partners/SOL.webp',
  '/pricing/partners/VETS.webp',
];

const PartnersScroll = () => {
  return (
    <RowComponent
      style={{
        paddingBottom: 64,
      }}
    >
      <HorizontalScroll
        icons={Icons.map((icon) => (
          <IconContainer>
            <Icon src={icon} />
          </IconContainer>
        ))}
      />
    </RowComponent>
  );
};

export default PartnersScroll;
